export const DEFAULT_VALUE_DASH = String.fromCharCode(parseInt('02014', 16))
export const DEFAULT_VALUE_FOR_SHIPPING = 'Billed by carrier'
export const SUBTOTAL_RFQ = 'RFQ'
export const IM_RFQ_PRICING_NOT_AVAILABLE = 'Pricing not added'
const CENTS_PER_DOLLAR = 100

export function priceWithCommas(x: number | string): string {
    const priceSplit = x.toString().split('.')

    priceSplit[0] = priceSplit[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return priceSplit.join('.')
}

/**
 * If price is undefined, returns the @defaultDisplay else formats the @priceInCents like $123,456.78
 */
export function getPriceDisplay(
    price: number | null | undefined,
    defaultDisplay = DEFAULT_VALUE_DASH,
    isPriceInCents = true,
    priceSymbol = '$',
): string {
    if (price || price === 0) {
        return isPriceInCents
            ? `${priceSymbol}${priceWithCommas(
                  (price / CENTS_PER_DOLLAR).toFixed(2),
              )}`
            : `${priceSymbol}${priceWithCommas(price.toFixed(2))}`
    }

    return defaultDisplay
}

export function getEstimatedPriceDisplay(
    lowPriceInCents: number | null | undefined,
    highPriceInCents: number | null | undefined,
): string {
    if (
        (lowPriceInCents || lowPriceInCents === 0) &&
        (highPriceInCents || highPriceInCents === 0)
    ) {
        const lowPrice = lowPriceInCents / CENTS_PER_DOLLAR
        const highPrice = highPriceInCents / CENTS_PER_DOLLAR

        return `$${priceWithCommas(lowPrice.toFixed(0))} - $${priceWithCommas(
            highPrice.toFixed(0),
        )}`
    }

    return DEFAULT_VALUE_DASH
}

export function getMoldsPriceDisplay(
    priceInCents: number | null | undefined,
): string {
    const priceDisplay = getPriceDisplay(priceInCents)
    const defaultMoldsPriceText = 'Price not added'

    return priceDisplay === DEFAULT_VALUE_DASH
        ? defaultMoldsPriceText
        : priceDisplay
}

export function getMachiningSubItemsPriceDisplay(
    costInPercentage: number,
): string {
    return costInPercentage < 5 ? `<5% Cost` : `~${costInPercentage}% Cost`
}
